export default (state, {payload}) => ({...state});
